import { useState } from "react";

import { useTimeout } from "usehooks-ts";

import { EventConfigEnriched } from "src/clients/features-control";
import { EventPill } from "src/copilot/EventPill";

type Props = {
  event: EventConfigEnriched;
  delay: number;
};

export const EventMention = ({ event, delay }: Props) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && (
      <span className="mx-1 inline-flex">
        <EventPill resource={event} />
      </span>
    )
  );
};
